export interface QualityEvalRule {
  title: string;
  detail: string;
}

/** 素质评价页浮窗展示的四大原则（概要 + 细项）。 */
export const QUALITY_EVAL_RULES: QualityEvalRule[] = [
  {
    title: '通关式打分，不允许越级',
    detail:
      '从最低档开始逐级判断 —— 只有满足了低档的全部要求，才能进入下一档。高分必须覆盖低分的所有要求。如果觉得某一档还没完全做到，就停在当前档位，不要往上走。',
  },
  {
    title: '基于事实，确保真实',
    detail:
      '请依据可观察的工作事实与具体行为举例打分，避免凭印象、传闻或主观推测。不足以支撑高分的信息不要使用；存疑时请保守选档或对不了解的维度勾选「不了解」。',
  },
  {
    title: '独立判断，保持客观',
    detail:
      '每位评价人独立作答，请勿与他人串通或对照分数再填写。避免因职级、关系或他人结论影响判断，仅以你对被评价人真实工作接触为依据。',
  },
  {
    title: '保密原则',
    detail:
      '评价过程与个人打分对他人保密，不得在盘点外向被评价人或无关同事透露具体内容、分差或评议意见，违者按公司相关纪律规定处理。',
  },
];

/** 素质评分「极端分值」：打这些分必须举具体事例（0=不了解/弃权也要写理由）。 */
export const EXTREME_SCORES = new Set([0, 1, 6, 7]);
export const EXTREME_COMMENT_MIN_LEN = 10;

export function isExtremeScore(score: number | undefined | null): boolean {
  return score !== undefined && score !== null && EXTREME_SCORES.has(Number(score));
}

/** 去空白后的有效字数（与后端校验口径一致）。 */
export function commentTextLen(comment: string | undefined | null): number {
  return (comment ?? '').replace(/\s/g, '').length;
}
